import React from 'react';
import { createRoot } from 'react-dom/client';

import { setLocale } from '../i18n';
import { getIsJoinEmployeeFlow } from 'features/joinEmployeeFlow/joinEmployeeFlow.utils';

export const mountPage = async (node: React.ReactNode) => {
  await setLocale('uk');
  const rootNode = document.getElementById('root');

  const isJoinEmployeeFlow = getIsJoinEmployeeFlow();

  if (!isJoinEmployeeFlow && rootNode) {
    rootNode.style.minWidth = '1200px';
  }

  if (rootNode) {
    createRoot(rootNode).render(<React.Suspense>{node}</React.Suspense>);
  }
};
